import moment from "moment";

export const dateFormatter = (value) => {
  if (!value) return "";
  const formatted = moment(value).format("MM/DD/YYYY hh:mm A");
  return formatted;
};
